import {
  DoctypeCsv16Px,
  DoctypeDocx16Px,
  DoctypePdf16Px,
  DoctypeXlsx16Px,
  MenuItem,
  Spinner,
} from '@galaxy-react/core';
import { FileItem } from 'src/services/db';
// import { iconsForFileFormat } from 'src/Shared/Components/FileFormatIcon';
import Tag from 'src/Shared/Components/Tag';
import Typography from 'src/Shared/Components/Typography';
import { getLocaleString } from 'src/Shared/Utilities/DateFormatter';

export const iconsForFileFormat = (fileFormat: string) => {
  switch (fileFormat) {
    case 'PDF':
      return <DoctypePdf16Px />;
    case 'XLSX':
      return <DoctypeXlsx16Px />;
    case 'CSV':
      return <DoctypeCsv16Px />;
    case 'DOCX':
      return <DoctypeDocx16Px />;
    default:
      return null;
  }
};
const DownloadItem = (props: FileItem & { onClick?: () => void; disabled?: boolean }) => {
  const { id, title, createdAt, status, format, onClick, disabled } = props;
  return (
    <MenuItem persistOnClick onClick={() => onClick?.()} disabled>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {iconsForFileFormat(format)}
        <div style={{ flex: 1, marginLeft: 12, marginRight: 12 }}>
          <Typography>{title}</Typography>
          <Typography variant="caption">{getLocaleString(createdAt)}</Typography>
        </div>
        {status === 'PENDING' ? (
          <Spinner size="tiny"></Spinner>
        ) : (
          <Tag type={status === 'DONE' ? 'success' : 'error'}>{status}</Tag>
        )}
      </div>
    </MenuItem>
  );
};

export default DownloadItem;
